import SimpleTitle from '../simpleComponents/simpleTitle';
import Head from 'next/head';
import React from 'react';
import {useTranslation} from 'next-i18next';
import MetaHead from '../meta/MetaHead';

export const TextLayoutPage = ({
                                 children,
                                 title,
                                 loseContainer,
                                 description,
                                 faqJsonLd,
                               }) => {
  const {t: translateSiteMeta} = useTranslation('site-meta');

  return <section className={'min-h-screen'}>

    <MetaHead
        title={translateSiteMeta('HEADER_TITLE_STANDARD',
            {
              siteTitle: title,
              brand: translateSiteMeta('BRAND'),
              slogan: translateSiteMeta('SLOGAN'),
            })}
        description={description}
        faqJsonLd={faqJsonLd}
    />

    <SimpleTitle title={title} loseContainer={!!loseContainer}>
      {children}
    </SimpleTitle>
  </section>;

};